import "jquery-validation"
import "../validator-rules";
import ssoTool from "../tools/sso.tool";
import ssoAlert from "../tools/sso.alert";
import ssoAjax from "../tools/sso.ajax";
import Swal from "sweetalert2";

function showSocialBindPopup() {
    const tpl = document.getElementById('social_bind_popup_tpl');

    Swal.fire({
        showConfirmButton: false,
        showClass: { popup: '' },
        customClass: {
            popup: 'sso-alert-social-bind-popup',
            htmlContainer: 'sso-alert-social-bind-html',
        },
        html: tpl ? tpl.innerHTML : '',
        didRender: function () {
            const container = $(Swal.getHtmlContainer());
            const passwordInput = container.find('#social_bind_password');
            const errorDiv = container.find('.social-bind-popup__error');
            const confirmBtn = container.find('#btn_social_bind_confirm');

            ssoTool.setInputEyeSwitch(passwordInput);

            container.find('#btn_social_bind_cancel').on('click', function () {
                Swal.close();
                return false;
            });

            confirmBtn.on('click', function () {
                const password = passwordInput.val();
                errorDiv.text('');

                if (!password) {
                    return false;
                }

                confirmBtn.prop('disabled', true).addClass('loading');

                const csrfToken = $('input[name="_token"]').first().val();

                $.ajax({
                    url: window.socialBindUrl,
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        token: window.socialBindToken,
                        password: password,
                        _token: csrfToken,
                    },
                }).done(function (response) {
                    const redirectUrl = response?.url || response?.data?.url;

                    Swal.close();
                    ssoAlert.success(window.socialBindSuccessText, {
                        didRender: function () {
                            $('#btn_close_sso_alert').on('click', function () {
                                Swal.close();

                                if (redirectUrl) {
                                    window.location.href = redirectUrl;
                                }

                                return false;
                            });
                        },
                    });
                }).fail(function (xhr) {
                    confirmBtn.prop('disabled', false).removeClass('loading');

                    const errorCode = xhr?.responseJSON?.code;
                    const errorMessage = xhr?.responseJSON?.message || 'something wrong';
                    const displayMessage = (errorCode && window.language?.[errorCode])
                        ? window.language[errorCode]
                        : (window.language?.[errorMessage] || errorMessage);

                    errorDiv.text(displayMessage);
                });

                return false;
            });
        },
    });
}

export function init() {
    if (window.socialLoginStatus === 'failed') {
        const reason = window.socialLoginError;
        if (reason === 'account_exists_but_social_not_bind') {
            showSocialBindPopup();
        } else {
            ssoAlert.error(window.language?.login?.error?.[reason] || reason);
        }
    }

    const loginForm = $('#login_form');
    const account = $('#account');
    const rememberMe = $('#remember_me');
    const btnSubmit = $('#btn_submit');

    function restoreRememberMe() {
        if (localStorage.getItem('remember_me')) {
            rememberMe.prop('checked', true);
        }

        if (localStorage.getItem('account')) {
            account.val(localStorage.getItem('account'));
        }
    }

    restoreRememberMe();

    ssoTool.setInputEyeSwitch('#password');
    ssoTool.setInputClearSwitch('#account');

    loginForm.validate({
        showErrors: function() {
            if (this.numberOfInvalids() > 0) {
                btnSubmit.addClass('disabled');
            } else {
                btnSubmit.removeClass('disabled');
            }

            this.defaultShowErrors();
        },
        errorElement: 'span',
        errorPlacement: function(error, element) {
            element.closest('.col').find('div.error-message').html(error);
        },
        submitHandler: function(form) {
            if (rememberMe.is(':checked')) {
                localStorage.setItem('remember_me', '1');
                localStorage.setItem('account', account.val());
            } else {
                localStorage.removeItem('remember_me');
                localStorage.removeItem('account');
            }

            ssoAjax.submit(form, function(response) {
                if (response.url) {
                    window.location = response.url;

                    return false;
                }

                if (response.status === false) {
                    const message = (window.language && window.language[response.message]) ? window.language[response.message] : response.message;

                    ssoAlert.error(message);
                }

                ssoAjax.btnSetToSubmit();
            });
        }
    });
}
